import React, { Component } from 'react'
import { CheckCircleOutlined, LeftOutlined, RightOutlined } from '@ant-design/icons'
import ProductRecommendation from '@/components/register/productRecommendation.js'
import Breadcrumb from "../common/breadcrumb";
import './index.css';
import { getToken } from "@/storage/LocalParamers";
import intl from "react-intl-universal";
import { loadLocales } from "@/utils/HandlerLocales";
import { putJumpLoginPage } from '@/storage/SessionParamers'
class OrderSuccess extends Component {
  constructor(props) {
    super(props);
    loadLocales('OrderSuccess')
  }
  newest = ref => {
    this.newestRef = ref;
  };
  offers = ref => {
    this.offersRef = ref;
  };
  render() {
    return (
      <div>
        <div className="containermb1">
          <div className='registration_successful'>
            <div className='registration_successful_scope'>
              <div className='registration_successful_icon'>
                <CheckCircleOutlined />
                <div>{intl.get("orderSuccessful")}</div>
              </div>
              <div className='registration_successful_tips'>
                {intl.get("PleaseWaitForDelivery")}“<span style={{ color: "#2e3092" }}>{intl.get("PersonalCentre-MyOrders")}</span>”{intl.get("lookIn")}。
              </div>
              <div className='order_success_btn'>
                <div className="registration_successful_keepShopping"
                  onClick={() => this.props.history.push("/no-sidebar/collection")}>
                  {intl.get("continueShopping")}
                </div>
                <div
                  className="registration_successful_viewOrder"
                  onClick={() => {
                    putJumpLoginPage(window.location.pathname);
                    getToken() ?
                      this.props.history.push(`${process.env.PUBLIC_URL}/personal-centre`) :
                      this.props.history.push(`${process.env.PUBLIC_URL}/pages/login`)
                  }}>
                  {intl.get("ViewOrder")}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*Regsiter section*/}
        <section className="register-page section-b-space">
          <div className="container container1">
            <div className="row">

            </div>
          </div >
        </section >
      </div >

    )
  }
}

export default OrderSuccess